'use client';

// 定义错误类型
export class AWSWafError extends Error {
  public readonly type: string;

  constructor(message: string, type: AWSWafErrorType) {
    super(message);
    this.name = 'AWSWafError';
    this.type = type;
  }
}

// 定义验证码错误类型
export type AWSWafErrorType =
  | 'load_failed' // 脚本加载失败
  | 'container_missing' // 容器不存在
  | 'render_failed' // 渲染失败
  | 'verification_failed' // 验证失败
  | 'unknown'; // 未知错误
